/* KORE Campaign Life — motor de la sección "Así vive la tienda de tu club"
   (sections/kore-campaign-life.liquid).

   La escena se ancla a la ventana mientras queden estados por ver, para que
   la sección siguiente no asome a medio recorrido. Dentro del anclaje el
   teléfono no se mueve: lo único que se desplaza es la columna de estados.

   El presupuesto de scroll NO se reserva a ojo: es exactamente lo que la
   columna no cabe en su marco, más un respiro sobre el último estado. Por
   eso anclar no alarga la página.

   Mejora progresiva. Si el JS no llega, si el usuario pide menos movimiento,
   si no caben dos columnas o si el teléfono no entra en el hueco, no se
   ancla nada: queda el flujo normal, con el teléfono pegado por CSS y los
   cinco estados legibles al 100 %.

   El teléfono va en una montura 3D ([data-kcl-rig]): gira despacio con el
   avance de la campaña —de cara a los estados al abrir, de frente al
   entregar— y se inclina hacia el ratón, con la misma inercia que los
   objetos de assets/kore-stage3d.js. Con movimiento reducido, quieto.

   La escena anclada descuenta el header flotante: antes la cabecera nacía
   debajo de él y el título quedaba medio tapado. */
(function () {
  'use strict';
  if (window.KoreCampaignLife) return;
  window.KoreCampaignLife = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var units = [];
  var raf = 0;
  var rafM = 0;
  var lastW = 0;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* Lo que tapa el header por arriba: su altura más el margen con que flota. */
  function alturaHeader() {
    var v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
    return isNaN(v) ? 0 : v + 10;
  }

  function build(wrap) {
    var stage = wrap.querySelector('[data-kcl-stage]');
    var list = wrap.querySelector('[data-kcl-states]');
    if (!stage || !list) return null;
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-kcl-state]'));
    if (!items.length) return null;
    return {
      wrap: wrap,
      stage: stage,
      list: list,
      items: items,
      frame: wrap.querySelector('[data-kcl-frame]'),
      move: wrap.querySelector('[data-kcl-move]'),
      head: wrap.querySelector('[data-kcl-head]'),
      phone: wrap.querySelector('[data-kcl-phone]'),
      rig: wrap.querySelector('[data-kcl-rig]'),
      cur: { f: 0, rx: 0, ry: 0 },
      tgt: { f: 0, rx: 0, ry: 0 },
      pinned: false,
      travel: 0,
      len: 0,
      frameH: 0,
      centers: [],
      last: -1
    };
  }

  function setup() {
    lastW = window.innerWidth;
    var wraps = Array.prototype.slice.call(document.querySelectorAll('[data-kcl]'));
    units = [];

    wraps.forEach(function (wrap) {
      var u = build(wrap);
      if (!u) return;
      units.push(u);

      /* Cada re-medida rehace la unidad: la montura conserva su postura
         para no saltar, y el ratón se escucha una sola vez por sección. */
      if (wrap._kclU) u.cur = wrap._kclU.cur;
      wrap._kclU = u;
      if (u.rig && fine.matches && !reduce.matches && !wrap.hasAttribute('data-kcl-ptr')) {
        wrap.setAttribute('data-kcl-ptr', '1');
        u.stage.addEventListener('pointermove', function (e) {
          var uu = wrap._kclU;
          if (e.pointerType !== 'mouse' || !uu) return;
          var r = uu.stage.getBoundingClientRect();
          uu.tgt.ry = clamp((e.clientX - r.left) / r.width - 0.5, -0.5, 0.5) * 12;
          uu.tgt.rx = clamp((e.clientY - r.top) / r.height - 0.5, -0.5, 0.5) * -8;
          moverPronto();
        });
        u.stage.addEventListener('pointerleave', function () {
          var uu = wrap._kclU;
          if (!uu) return;
          uu.tgt.rx = 0; uu.tgt.ry = 0;
          moverPronto();
        });
      }

      /* Estado base: sin anclaje y sin nada inyectado por una medida previa. */
      u.wrap.classList.remove('kcl--pinned');
      u.wrap.style.height = '';
      u.stage.style.paddingTop = '';
      u.frame.style.removeProperty('--kcl-frame');
      u.move.style.transform = '';
      u.move.style.paddingTop = '';
      u.move.style.paddingBottom = '';
      if (reduce.matches && u.rig) u.rig.style.transform = '';
      u.pinned = false;
      u.last = -1;
      /* El atenuado de los estados inactivos solo tiene sentido si hay un
         cabezal de lectura que lo justifique. Sin JS los cinco van enteros. */
      u.list.classList.add('kcl--live');

      var vh = window.innerHeight;
      if (reduce.matches || window.innerWidth <= 700 || vh < 520) return;

      u.wrap.classList.add('kcl--pinned');
      /* La escena anclada ocupa la ventana entera y el header flota encima:
         el contenido empieza por debajo de él, con aire. */
      u.stage.style.paddingTop = Math.round(alturaHeader() + 18) + 'px';

      /* Hueco real para la columna, medido —no estimado— ya con la escena
         compactada: la ventana menos el relleno de la banda (header
         incluido) y la cabecera con su margen. */
      var cs = getComputedStyle(u.stage);
      var padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
      var headY = u.head.offsetHeight + (parseFloat(getComputedStyle(u.head).marginBottom) || 0);
      var avail = vh - padY - headY;

      /* Si el teléfono no cabe, anclar lo recortaría contra el borde de la
         escena. Antes que enseñarlo cortado, flujo normal. */
      if (avail < u.phone.offsetHeight + 16) {
        u.wrap.classList.remove('kcl--pinned');
        return;
      }

      u.frameH = Math.max(240, avail);
      u.frame.style.setProperty('--kcl-frame', u.frameH + 'px');

      /* Espaciadores. El cabezal de lectura vive en el centro del marco, así
         que sin ellos no alcanza ni al primer estado ni al último: la columna
         se queda sin recorrido antes de tiempo. Con ellos el primero nace
         centrado y el último termina centrado. */
      var h0 = u.items[0].offsetHeight;
      var hN = u.items[u.items.length - 1].offsetHeight;
      u.padTop = Math.max(0, Math.round(u.frameH / 2 - h0 / 2));
      u.move.style.paddingTop = u.padTop + 'px';
      u.move.style.paddingBottom = Math.max(0, Math.round(u.frameH / 2 - hN / 2)) + 'px';
      u.listH = u.list.offsetHeight;

      /* Centro de cada estado dentro del carro, medido una sola vez y sin
         transform aplicado. */
      var mt = u.move.getBoundingClientRect().top;
      u.centers = u.items.map(function (el) {
        var r = el.getBoundingClientRect();
        return r.top - mt + r.height / 2;
      });

      u.travel = Math.max(0, u.move.offsetHeight - u.frameH);
      u.len = u.travel + Math.round(vh * 0.3);
      u.wrap.style.height = (vh + u.len) + 'px';
      u.pinned = true;
    });

    update();
  }

  function nearest(centers, y) {
    var idx = 0;
    var best = Infinity;
    for (var i = 0; i < centers.length; i++) {
      var d = Math.abs(centers[i] - y);
      if (d < best) { best = d; idx = i; }
    }
    return idx;
  }

  function update() {
    raf = 0;
    for (var n = 0; n < units.length; n++) {
      var u = units[n];
      var idx, i;

      /* Dos medidas distintas: `avance` (0..1 de todo el recorrido) gira el
         teléfono; `linea` lleva el hilo de luz y su cabezal hasta la línea
         de lectura, que es donde está el estado activo. */
      var avance, linea;
      if (!u.pinned) {
        /* Flujo normal: manda un cabezal fijo sobre la ventana. */
        var h = window.innerHeight * 0.42;
        idx = 0;
        for (i = 0; i < u.items.length; i++) {
          if (u.items[i].getBoundingClientRect().top <= h) idx = i;
        }
        var a = u.items[0].getBoundingClientRect().top;
        var b = u.items[u.items.length - 1].getBoundingClientRect().top;
        avance = clamp((b === a) ? 0 : (h - a) / (b - a), 0, 1);
        var lr = u.list.getBoundingClientRect();
        linea = clamp((h - lr.top - 8) / Math.max(1, lr.height - 16), 0, 1);
      } else {
        var gone = clamp(-u.wrap.getBoundingClientRect().top, 0, u.len);
        var ty = Math.min(gone, u.travel);
        u.move.style.transform = 'translate3d(0,' + (-ty) + 'px,0)';
        avance = u.travel ? clamp(ty / u.travel, 0, 1) : 1;
        linea = clamp((ty + u.frameH * 0.5 - u.padTop - 8) / Math.max(1, u.listH - 16), 0, 1);
        idx = nearest(u.centers, ty + u.frameH * 0.5);
      }
      u.list.style.setProperty('--kcl-fill', linea.toFixed(3));
      if (u.tgt.f !== avance) { u.tgt.f = avance; moverPronto(); }

      if (idx === u.last) continue;
      u.last = idx;
      u.stage.setAttribute('data-kcl-on', String(idx));
      for (i = 0; i < u.items.length; i++) {
        u.items[i].classList.toggle('is-on', i === idx);
      }
    }
  }

  // ── Montura 3D del teléfono ───────────────────────────────────
  function acercar(c, t, p, k, eps) {
    c[p] += (t[p] - c[p]) * k;
    if (Math.abs(t[p] - c[p]) < eps) c[p] = t[p];
    return c[p] !== t[p];
  }

  function mover() {
    rafM = 0;
    var sigue = false;
    for (var n = 0; n < units.length; n++) {
      var u = units[n];
      if (!u.rig) continue;
      var c = u.cur, t = u.tgt;
      if (acercar(c, t, 'f', 0.12, 0.0005)) sigue = true;
      if (acercar(c, t, 'rx', 0.09, 0.01)) sigue = true;
      if (acercar(c, t, 'ry', 0.09, 0.01)) sigue = true;
      /* De cara a los estados al abrir (16°), casi de frente al entregar (2°). */
      u.rig.style.transform = 'rotateY(' + (16 - 14 * c.f + c.ry).toFixed(2) + 'deg) ' +
        'rotateX(' + (5 - 3 * c.f + c.rx).toFixed(2) + 'deg)';
    }
    if (sigue) rafM = requestAnimationFrame(mover);
  }

  function moverPronto() {
    if (reduce.matches || rafM) return;
    rafM = requestAnimationFrame(mover);
  }

  function onScroll() {
    if (!raf && units.length) raf = requestAnimationFrame(update);
  }

  var timer = 0;
  function onResize() {
    /* El vaivén de la barra de URL en móvil no debe re-medir la escena. */
    if (window.innerWidth === lastW) return;
    clearTimeout(timer);
    timer = setTimeout(setup, 180);
  }

  /* El tema desplaza .page-wrapper en escritorio, no window: con capture
     se recoge el scroll venga del contenedor que venga. */
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', onResize);
  window.addEventListener('load', setup);
  document.addEventListener('shopify:section:load', setup);
  if (reduce.addEventListener) reduce.addEventListener('change', setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
